import React from "react";
import { Stack, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import dayjs from "dayjs";

import {
  DialogButton,
  HubBackButton,
  HubHookFormDatePicker,
} from "../../components";

import DisplayLocation from "./DisplayLocation";
import WorkerView from "./WorkerView";
import ContextMenu from "./ContextMenu";

import { StyledTitleStack } from "./styles";

const today = dayjs().utc();
const lastMonth = today.add(-1, "week").startOf("week").toISOString();
const threeMonths = today.add(2, "month").endOf("month").toISOString();

export const DisplayPageBar = ({
  startDate = lastMonth,
  endDate = threeMonths,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const onDateChange = (val, field) => {
    setSearchParams((prev) => {
      const value = dayjs(val).toISOString();
      const newEndDate = field === "endDate" ? value : prev.get("endDate");
      const newStartDate =
        field === "startDate" ? value : prev.get("startDate");

      return {
        startDate: newStartDate || startDate,
        endDate: newEndDate || endDate,
      };
    });
  };

  const defaultStartDate = dayjs(searchParams.get("startDate")).isValid()
    ? searchParams.get("startDate")
    : startDate;
  const defaultEndDate = dayjs(searchParams.get("endDate")).isValid()
    ? searchParams.get("endDate")
    : endDate;

  return (
    <StyledTitleStack>
      <Stack direction="row" gap="10px" alignItems="center">
        <HubBackButton />
        <Stack direction="row" gap="10px" alignItems="center">
          <DisplayLocation />
          {/* <Typography variant="caption11">From</Typography>
          <HubHookFormDatePicker
            name="startDate"
            defaultValue={defaultStartDate}
            onChange={(val) => onDateChange(val, "startDate")}
            required
          />
          <Typography variant="caption11">To</Typography>
          <HubHookFormDatePicker
            name="endDate"
            defaultValue={defaultEndDate}
            onChange={(val) => onDateChange(val, "endDate")}
            required
          /> */}
        </Stack>
      </Stack>

      <Stack direction="row" gap="10px" p="0 15px" alignItems="center">
        <WorkerView />

        <DialogButton
          name="create-display"
          label="Create Display"
          variant="contained"
          size="xsmall"
        />
        <ContextMenu />
      </Stack>
    </StyledTitleStack>
  );
};

export default DisplayPageBar;
